import _styled from "@emotion/styled/base";
export const Icon = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e16x7c9q0"
} : {
  target: "e16x7c9q0",
  label: "Icon"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQytCIiwiZmlsZSI6Ikljb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5leHBvcnQgY29uc3QgSWNvbiA9IHN0eWxlZC5kaXYgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1JY29uLmpzLm1hcCJdfQ== */");